export const MATERIAL_SOURCE_VALUES = {
  STOCK: "Stock",
  PICKUP: "Pickup",
  ORDER: "Order",
};

export const MATERIAL_SOURCES = {
  ORDER: MATERIAL_SOURCE_VALUES.ORDER,
  RESTOCK: "Restock",
};
